import React, { useState } from 'react';

function SurveyStepEighteen({ formData, onNext }) {
    const [inclusivityRating, setInclusivityRating] = useState(formData.inclusivityRating || '');
    const [inclusivityComments, setInclusivityComments] = useState(formData.inclusivityComments || '');
    const [error, setError] = useState('');

    const handleContinue = () => {
        if (!inclusivityRating) {
            setError('Please select a rating.');
            return;
        }
        setError('');
        onNext({ inclusivityRating, inclusivityComments });
    };

    const ratingOptions = ['N/A', ...Array.from({ length: 10 }, (_, i) => (i + 1).toString())];

    return (
        <div className="step-form">
            <h6 className="mb-4">Section 4: Workplace & Culture</h6>

            {error && <div className="alert alert-danger">{error}</div>}

            <label className="form-label">
                How inclusive and respectful do you feel the workplace is? <span className="text-danger">*</span>
            </label>

            <div className="d-flex flex-wrap gap-2 mb-4 justify-content-around">
                {ratingOptions.map((option) => (
                    <div key={option} className="form-check rating_btn">
                        <input
                            type="radio"
                            id={`inclusivity-rating-${option}`}
                            name="inclusivityRating"
                            value={option}
                            checked={inclusivityRating === option}
                            onChange={() => setInclusivityRating(option)}
                        />
                        <label htmlFor={`inclusivity-rating-${option}`}>{option}</label>
                    </div>
                ))}
            </div>

            <div className="mb-3">
                <label className="form-label">Additional comments (optional):</label>
                <textarea
                    className="form-control"
                    rows="4"
                    value={inclusivityComments}
                    onChange={(e) => setInclusivityComments(e.target.value)}
                    placeholder="Share any additional thoughts here..."
                />
            </div>

            <div className="text-end mt-5">
                <button
                    className="btn btn-dark px-4"
                    onClick={handleContinue}
                    disabled={!inclusivityRating}
                >
                    Next
                </button>
            </div>
        </div>
    );
}

export default SurveyStepEighteen;
